import { combineReducers } from 'redux';
import { reducer as crudReducer } from './crud';
import { reducer as advancedCrudReducer } from './advancedCrud';
import { reducer as erpReducer } from './erp';
import { reducer as settingsReducer } from './settings';
import { reducer as translateReducer } from './translate';
import authReducer from './auth/reducer';

// Combine all reducers.

const rootReducer = combineReducers({
  auth: authReducer,
  crud: crudReducer,
  erp: erpReducer,
  advancedCrud: advancedCrudReducer,
  settings: settingsReducer,
  translate: translateReducer,
});

export default rootReducer;
